import axios from 'axios';

/**
 * Retour visuel à chaque clic qui enregistre (21/10/2026) : partout dans l'application, sans toucher chaque écran.
 * - le bouton cliqué tourne et ne se reclique pas tant que le serveur n'a pas répondu (double clic évité) ;
 * - au-delà de 0,7 s, un bandeau « Enregistrement en cours… » s'affiche en bas de l'écran.
 * Seules les écritures (POST, PUT, PATCH, DELETE) lancées juste après un clic sont suivies : les sauvegardes
 * automatiques et les lectures ne déclenchent rien.
 */
const DELAI_CLIC = 1500;   // ms entre la fin du clic (fenêtre de confirmation comprise) et le départ de la requête
const DELAI_BANDEAU = 700;

let dernier = { bouton: null, t: 0 };
let enCours = 0;
let minuteur = null;
let bandeau = null;

const boutonDe = (cible) => (cible && cible.closest ? cible.closest('button, [role="button"], a') : null);

// Capture : le bouton est connu avant le gestionnaire React (l'appel axios part pendant le clic).
// « pendant » couvre une fenêtre de confirmation, quelle que soit sa durée ; le délai court ensuite, à la fin du clic.
window.addEventListener('click', (e) => {
  const b = boutonDe(e.target);
  if (!b) return;
  dernier = { bouton: b, t: Date.now(), pendant: true };
  setTimeout(() => { if (dernier.bouton === b) dernier = { bouton: b, t: Date.now(), pendant: false }; }, 0);
}, true);

function afficherBandeau(oui) {
  if (oui && !bandeau) {
    bandeau = document.createElement('div');
    bandeau.className = 'dmo-bandeau-occupe';
    bandeau.setAttribute('role', 'status');
    bandeau.textContent = 'Enregistrement en cours…';
    document.body.appendChild(bandeau);
  } else if (!oui && bandeau) {
    bandeau.remove();
    bandeau = null;
  }
}

function debut(cfg) {
  const methode = (cfg.method || 'get').toLowerCase();
  if (methode === 'get' || cfg.__isRetryRequest || (cfg.url || '').includes('/api/auth/')) return;
  if (!dernier.bouton || (!dernier.pendant && Date.now() - dernier.t > DELAI_CLIC)) return;
  const b = dernier.bouton;
  cfg.__dmoBouton = b;
  b.__dmoN = (b.__dmoN || 0) + 1;
  b.classList.add('dmo-occupe');
  b.setAttribute('aria-busy', 'true');
  enCours += 1;
  cfg.__dmoSuivi = true;
  setTimeout(() => fin(cfg), 180000);   // filet : jamais de bouton bloqué au-delà de 3 min
  if (!minuteur) minuteur = setTimeout(() => { minuteur = null; if (enCours > 0) afficherBandeau(true); }, DELAI_BANDEAU);
}

function fin(cfg) {
  if (!cfg || !cfg.__dmoSuivi) return;
  cfg.__dmoSuivi = false;
  const b = cfg.__dmoBouton;
  if (b) {
    b.__dmoN = Math.max(0, (b.__dmoN || 1) - 1);
    if (!b.__dmoN) { b.classList.remove('dmo-occupe'); b.removeAttribute('aria-busy'); }
  }
  enCours = Math.max(0, enCours - 1);
  if (!enCours) {
    if (minuteur) { clearTimeout(minuteur); minuteur = null; }
    afficherBandeau(false);
  }
}

// Importé AVANT axiosSetup : ce suivi se termine sur la première réponse, même un 401 rejoué ensuite par axiosSetup
axios.interceptors.request.use((cfg) => { try { debut(cfg); } catch (e) { /* jamais bloquant */ } return cfg; });
axios.interceptors.response.use(
  (res) => { fin(res.config); return res; },
  (err) => { fin(err.config); return Promise.reject(err); },
);
